module.exports = __webpack_public_path__ + "img/shopping-list.47fe98e9.png";